import React from "react";

import { useTicketTransferNewContext } from "./TicketTransferNewContainer";
import TicketSelect from "./TicketSelect";
import RecipientForm from "./RecipientForm";

const navigationControlStyle = {
  display: "flex",
  background: "#ECECEC",
  padding: "20px",
  borderRadius: "8px",
  gap: "20px",
  alignItems: "center",
  marginBottom: "20px",
};

const TicketTransferNew = () => {
  const {
    step,
    setStep,
    isSubmitting,
  } = useTicketTransferNewContext();

  return (
    <div style={{
      pointer: isSubmitting ? "none" : "auto",
    }}>
      <div style={navigationControlStyle}>
        <div onClick={() => setStep("Choose your tickets")} style={{
          color: step === "Choose your tickets" ? "#000000" : "#00000080",
        }}>
          1. Choose your tickets
        </div>
        <i className="fas fa-chevron-right" />
        <div style={{
          color: step === "Enter recipient details" ? "#000000" : "#00000080",
        }}>
          2. Enter recipient details
        </div>
      </div>
      {step === "Choose your tickets" ? (
        <TicketSelect />
      ) : (
        <RecipientForm />
      )}
    </div>
  );
};

export default TicketTransferNew;
